// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__9SvTW","alert":"SettungsInbox_alert__2UbGZ"};